import NotasCreditos from './NotasCreditos';
export default NotasCreditos;